import React, { useState } from 'react';
import { Box, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Typography, useMediaQuery, useTheme, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CommonForm from 'components/commonForm/CommonForm';
import CompanyLogo from "assets/images/companyLogo.svg";

export default function CommonDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [domainInput, setDomainInput] = useState(props?.defaultValues?.clientUrl || '');
  const [statusInput, setStatusInput] = useState(props?.defaultValues?.status || 'Active');
  
  const handleClose = () => {
    // Clear domain input when closing
    if (props.selectType === 'updateDomain') {
      setDomainInput('');
    }
    props.handleClose();
    if(props?.toggle){
    props?.toggle()}
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        sx={{ 
          "& .MuiDialog-paper": { 
            borderRadius: "10px",
            maxWidth: props.formName === "couponForm" ? "1200px" : "600px",
            width: "100%"
          } 
        }}
      >
        <DialogTitle id="responsive-dialog-title" className='modelMain'>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className="modelCloseIcon"
          >
            <CloseIcon />
          </IconButton>
          <Grid container>
            <Grid item xs={12} className="dialogHead">
              {props.selectType === 'Send' ? (
                <Typography>
                  {props.selectType === 'Send' ? props.type : ''}
                </Typography>
              ) : props.selectType === 'edit' ? (
                <Typography className="titleStyle">
                  {props?.type?.split(' ').slice(0, 1)}{' '}
                  <span className="colorSecondary">
                    {props?.type?.split(' ').slice(1).join(' ')}
                  </span>
                </Typography>
              ) : props.selectType === 'create' ? (
                <Typography className="titleStyle">
                  {'Add '}
                  <span className="colorSecondary">{props.type}</span>
                </Typography>
              ) : props.selectType === "Copy" ? (
                <Typography
                  component={"h1"}
                  fontSize={"30px"}
                  className="titleStyle fw700 colorPrimary pt20"
                >
                  {"Copy "}
                  <span className="colorSecondary">{props.type}</span>
                </Typography>
              ) : props.selectType === "updateDoc" ? ( <Typography
                component={"h1"}
                fontSize={"28px"}
                className="titleStyle fw600 colorPrimary pt20 flex"
              >
               <img src={CompanyLogo} alt='company' className="mr10"/> {props?.companyDetails?.companyName}
              </Typography>
            ) : props.selectType === 'vendorAdd' ? (
                <Typography className="titleStyle">
                  {'Enter '} {props.type}
                  <span className="colorSecondary">{' Details'}</span>
                </Typography>
              ): props.selectType === 'delete' ? (
                <Typography className="titleStyle">
                  {'Delete '} 
                  {/* <span className="colorSecondary">{' Coupon'}</span> */}
                  <span className="colorSecondary">{props.typeOfDialog}</span>
                </Typography>
              ) : props.selectType === 'updateDomain' ? (
                <Typography className="titleStyle">
                  {'Update '}
                  <span className="colorSecondary">{props.typeOfDialog}</span>
                </Typography>
              ) : props.selectType === 'updateStatus' ? (
                <Typography className="titleStyle">
                  {'Update '}
                  <span className="colorSecondary">{props.typeOfDialog}</span>
                </Typography>
              ): null}
            </Grid>
          </Grid>
        </DialogTitle>
        {props?.text ? <p className='colorBlack px-4 text-center'>{props?.text}</p> : null}
        <DialogContent 
        sx={{
          width: "100%",
          padding: "24px 24px 40px 24px" 
        }}>
          <DialogContentText>
            {props.selectType === 'updateDomain' ? (
              <Box>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 500, color: 'rgba(0, 0, 0, 0.6)' }}>
                  Domain URL
                </Typography>
                <TextField
                  fullWidth
                  placeholder="https://example.com"
                  value={domainInput}
                  onChange={(e) => {
                    setDomainInput(e.target.value);
                    props.onDomainUrlChange?.(e.target.value);
                  }}
                  variant="outlined"
                  size="medium"
                  error={!!props.domainUrlError}
                />
                {props.domainUrlError && (
                  <Typography variant="caption" sx={{ color: '#d32f2f', mt: 0.5, display: 'block' }}>
                    {props.domainUrlError}
                  </Typography>
                )}
              </Box>
            ) : props.selectType === 'updateStatus' ? (
              <Box>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel component="legend">Select Status</FormLabel>
                  <RadioGroup
                    value={statusInput}
                    onChange={(e) => setStatusInput(e.target.value)}
                    sx={{ mt: 2 }}
                  >
                    <FormControlLabel
                      value="Active"
                      control={<Radio />}
                      label="Active"
                    />
                    <FormControlLabel
                      value="InActive"
                      control={<Radio />}
                      label="InActive"
                    />
                    <FormControlLabel
                      value="InProgress"
                      control={<Radio />}
                      label="InProgress"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            ) : (
              <Grid container>
                <Grid item xs={12} className="formPadding">
                  <CommonForm
                    formData={props.formData}
                    button={props.button}
                    onSubmittBtn={props.onSubmittBtn}
                    selectType={props.selectType}
                    handleClose={handleClose}
                    type={props.type}
                    defaultValues={props?.defaultValues}
                    optionData={props?.optionData}
                    onImageHandleChange={props?.onImageHandleChange}
                    formName={props?.formName}
                    onDependentFieldChange={props?.onDependentFieldChange}
                    enableSaveAsDraft={props?.enableSaveAsDraft}
                  />
                </Grid>
              </Grid>
            )}

            {props.selectType === 'delete' ?
            <Box>
             <Grid container className="btnDialogContainer">
                <Grid item xs={5}>
                  <Button
                    variant="contained"
                    size="medium"
                    className="buttonSubmit"
                    type="submit"
                    fullWidth
                    onClick={() => {
                      props?.onConfirmDialog();
                    }}
                  >
                    Delete
                  </Button>
                </Grid>
                <Grid item xs={5}>
                <Button
                    variant="contained"
                    size="medium"
                    className="cancelAddBtn"
                    fullWidth
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box> : props.selectType === 'updateDomain' ?
            <Box>
             <Grid container className="btnDialogContainer">
                <Grid item xs={5}>
                  <Button
                    variant="contained"
                    size="medium"
                    className="buttonSubmit"
                    fullWidth
                    onClick={() => {
                      props?.onConfirmDialog({ clientUrl: domainInput });
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
                <Grid item xs={5}>
                <Button
                    variant="contained"
                    size="medium"
                    className="cancelAddBtn"
                    fullWidth
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box> : props.selectType === 'updateStatus' ?
            <Box>
             <Grid container className="btnDialogContainer">
                <Grid item xs={5}>
                  <Button
                    variant="contained"
                    size="medium"
                    className="buttonSubmit"
                    fullWidth
                    onClick={() => {
                      props?.onConfirmDialog({ status: statusInput });
                    }}
                  >
                    Update
                  </Button>
                </Grid>
                <Grid item xs={5}>
                <Button
                    variant="contained"
                    size="medium"
                    className="cancelAddBtn"
                    fullWidth
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box> : null}
          </DialogContentText>

        </DialogContent>
      </Dialog>
    </div>
  );
}